module.exports = __webpack_public_path__ + "static/media/BTCB-BUSD.6c80ea4f.svg";